<template>
	<div>
		<template v-if="component == 'map-layers' && activeWidget">
			<v-badge
				overlap
				:color="color"
			>
				<template v-slot:badge>
					<template v-if="status == 'added'">
						+1
					</template>
					<template v-else-if="status == 'removed'">
						-1
					</template>
				</template>
				<span>{{title}}</span>
			</v-badge>
		</template>
		<template v-else>
			<span>{{title}}</span>
		</template>
	</div>
</template>

<script>
	export default {
		data: function(){
			var data = {
				status: null,
				color: null
			};
			return data;
		},
		props: {
			title: String,
			component: String
		},
		computed: {
			activeWidget: {
				get: function(){
					return this.$store.state.activeWidget;
				}
			}
		},
		methods: {
			hideBadgeAfterTimeout: function(){
				clearTimeout(this.timeout);
				this.timeout = setTimeout(this.hideBadge, 850);
			},
			hideBadge: function(){
				this.status = null;
			}
		},
		watch: {
			status: {
				immediate: true,
				handler: function(status){
					var color = "transparent";
					if (status == "added") {
						color = "green";
					} else if (status == "removed") {
						color = "red";
					}
					this.color = color;
				}
			},
			activeWidget: {
				immediate: true,
				handler: function(activeWidget){
					if (activeWidget && activeWidget.content.type == "map" && activeWidget.content.data && activeWidget.content.data.myMap) {
						var myMap = activeWidget.content.data.myMap;
						if (myMap.map) {
							myMap.map.getLayers().on("add", function(e){
								if (e.element.service) {
									this.status = "added";
									this.hideBadgeAfterTimeout();
								}
							}.bind(this));
							myMap.map.getLayers().on("remove", function(e){
								if (e.element.service) {
									this.status = "removed";
									this.hideBadgeAfterTimeout();
								}
							}.bind(this));
						}
					}
				}
			}
		}
	}
</script>